export const INIT_APP = 'INIT_APP';
